module.exports = __webpack_public_path__ + "static/img/banner3.ee1f516.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner3.jpg
// module id = rLH5
// module chunks = 0